import { useState } from "react";
import UpdateModal from "./updateModal";
import Button from "../../../components/button";
import { useSelector } from "react-redux";
import { API_BASE_URL } from "../../../api/endpoint";

const TermsAndConditions = ({ fetchConfig }) => {
  const [isUpdateOpen, setIsUpdateOpen] = useState(false);
  const { config } = useSelector((state) => state.config);

  return (
    <div className="my-3">
      <div className="d-flex justify-content-end">
        <Button
          text="Update Terms and Conditions"
          callBack={() => setIsUpdateOpen(true)}
        />
      </div>
      {config?.termsAndConditionFile ? (
        // <div className="my-3" style={{ height: "100vh" }}>
        //   <object
        //     data={`${API_BASE_URL}public/images/${config?.termsAndConditionFile}`}
        //     type="application/pdf"
        //     width="100%"
        //     height="100%"
        //   />
        //   <iframe
        //     src={`${API_BASE_URL}public/images/${config?.termsAndConditionFile}`}
        //     width="100%"
        //     height="100%"
        //     style={{ border: "none" }}
        //   >
        //     <p>
        //       Your browser does not support PDFs.{" "}
        //       <a
        //         href={`${API_BASE_URL}public/images/${config?.termsAndConditionFile}`}
        //         target="_blank"
        //       >
        //         Download PDF
        //       </a>
        //     </p>
        //   </iframe>
        // </div>
        <a
          href={`${API_BASE_URL}public/images/${config?.termsAndConditionFile}`}
          target="_blank"
        >
          View File
        </a>
      ) : (
        <div>No Terms and Conditions File Uploaded</div>
      )}
      <UpdateModal
        isUpdateOpen={isUpdateOpen}
        closeUpdateModal={() => setIsUpdateOpen(false)}
        fetchConfig={fetchConfig}
      />
    </div>
  );
};

export default TermsAndConditions;
